module.exports = __webpack_public_path__ + "img/tour-49.7570f91e.png";